function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Link } from 'react-router-dom';
import { Image } from '../../Image';
import { StyledItem } from './StyledItem';
var getTabProps = function getTabProps(tab) {
  if (tab.to) {
    return {
      to: tab.to,
      as: Link
    };
  }
  if (tab.link) {
    return tab.link.type === 'client' ? {
      to: tab.link.href,
      as: Link
    } : {
      href: tab.link.href,
      as: 'a'
    };
  }
  return {};
};
var TabItem = function (_React$Component) {
  _inherits(TabItem, _React$Component);
  var _super = _createSuper(TabItem);
  function TabItem() {
    var _this;
    _classCallCheck(this, TabItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      active: _this.props.active
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      if (_this.props.tab.to || _this.props.tab.link || _this.props.disabled) {
        return;
      }
      _this.props.onClick(_this.props.tabIndex);
    });
    return _this;
  }
  _createClass(TabItem, [{
    key: "render",
    value: function render() {
      var active = this.state.active;
      var _this$props = this.props,
        _this$props$color = _this$props.color,
        color = _this$props$color === void 0 ? 'terciaryD' : _this$props$color,
        _this$props$titleColo = _this$props.titleColor,
        titleColor = _this$props$titleColo === void 0 ? 'terciaryD' : _this$props$titleColo,
        tab = _this$props.tab,
        _this$props$variant = _this$props.variant,
        variant = _this$props$variant === void 0 ? 'tabs' : _this$props$variant,
        _this$props$size = _this$props.size,
        size = _this$props$size === void 0 ? 'large' : _this$props$size,
        _this$props$disabled = _this$props.disabled,
        disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
        forwardRef = _this$props.forwardRef;
      var tabProps = getTabProps(tab);
      return React.createElement(StyledItem, _extends({
        ref: forwardRef,
        $withIcon: Boolean(tab.icon),
        $content: this.props.children,
        $isActive: active,
        $colorId: color,
        $titleColorId: titleColor,
        $variant: variant,
        disabled: disabled,
        onClick: this.handleClick,
        size: size
      }, tabProps), tab.icon ? React.createElement("figure", null, React.createElement(Image, {
        src: tab.icon,
        format: "png",
        width: variant === 'columns' ? 140 : 24,
        height: variant === 'columns' ? 65 : 24
      })) : null, React.createElement("span", null, this.props.children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.active !== prevState.active) {
        return {
          active: nextProps.active
        };
      }
      return null;
    }
  }]);
  return TabItem;
}(React.Component);
var TabsWithForward = React.forwardRef(function (props, ref) {
  return React.createElement(TabItem, _extends({}, props, {
    forwardRef: ref
  }));
});
export default TabsWithForward;